import { render, staticRenderFns } from "./DomicilioElectoral.vue?vue&type=template&id=75c6a2b4"
import script from "./DomicilioElectoral.vue?vue&type=script&lang=js"
export * from "./DomicilioElectoral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports